import { Navigate, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useUser } from '../hooks/User';
import { PrivatePage, PrivatePageProps } from "../components/template_page/private";
import { useEffect } from 'react';

interface PrivateRouteProps extends PrivatePageProps { }

const PrivateRoute = ({ children, ...restProps }: PrivateRouteProps): JSX.Element => {

  const isLogged = useUser().getDataByAttributeName("isLogged");
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location])

  // Redirect them to the "/" page, but save the current location they were
  // trying to go to when they were redirected. This allows us to send them
  // along to that page after they login, which is a nicer user experience
  // than dropping them off on the home page.

  if (!isLogged) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return (
    <PrivatePage {...restProps}>
      {children}
    </PrivatePage>
  );
}

// PrivateRoute.defaultProps = defaultPrivatePageProps;
export default PrivateRoute
